<template>
  <div>
    <b-sidebar
      id="sidebar-publish-manual-version"
      sidebar-class="sidebar-lg"
      :visible="publishManualVersionSidebar.visible"
      bg-variant="white"
      shadow
      backdrop
      no-header
      right
      @change="(val) => mutatePublishManualVersionSidebar({ visible: val })"
      @hidden="clear"
    >
      <template #default="{ hide }">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <h4>Nova versão — {{ publishManualVersionSidebar.manualName }}</h4>
          <div>
            <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
          </div>
        </div>
        <b-alert show variant="warning" class="mx-1 mt-1 p-1">
          Publicar uma nova versão não altera as versões anteriores. Aceites já
          registrados continuam vinculados ao arquivo que o franqueado
          efetivamente confirmou.
        </b-alert>
        <b-form @submit.prevent="onSubmit" class="p-1">
          <!-- Version -->
          <b-row>
            <b-col class="mt-1">
              <b-form-group label="Versão" label-for="publish-manual-version">
                <b-form-input
                  id="publish-manual-version"
                  v-model="version"
                  placeholder="Ex: 2.1"
                  :class="{ 'is-invalid': v$.version.$error }"
                />
                <div class="invalid-feedback">
                  <span v-if="v$.version.required.$invalid">Você deve informar a versão</span>
                </div>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- File -->
          <b-row>
            <b-col class="mt-1">
              <file-chooser
                id="publish-manual-file"
                label="Arquivo do manual"
                onlyPDF
                v-model="file"
                :thereIsError="v$.file.$error"
                errorMessage="Você deve anexar o arquivo do manual (PDF)"
              />
            </b-col>
          </b-row>

          <!-- Requires new acceptance -->
          <b-row>
            <b-col class="mt-1">
              <b-form-checkbox id="publish-manual-requires-acceptance" v-model="requiresNewAcceptance" switch inline>
                Exigir novo ciclo de aceite dos franqueados
              </b-form-checkbox>
            </b-col>
          </b-row>

          <!-- Form Actions -->
          <b-row>
            <b-col class="mt-1">
              <div class="d-flex mt-2">
                <b-button :disabled="saving" variant="primary" class="mr-2" type="submit">
                  {{ saving ? "Publicando..." : "Publicar versão" }}
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-form>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormCheckbox, BButton, BRow, BCol, BAlert,
} from 'bootstrap-vue'
import { mapActions, mapMutations, mapGetters } from 'vuex'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import FileChooser from '@/modules/shared/components/FileChooser'
import * as types from '../store/types'

export default {
  components: {
    BSidebar, BForm, BFormGroup, BFormInput, BFormCheckbox, BButton, BRow, BCol, BAlert,
    FileChooser,
  },
  data() {
    return {
      version: undefined,
      file: undefined,
      requiresNewAcceptance: true,
      saving: false,
    }
  },
  computed: {
    ...mapGetters({
      publishManualVersionSidebar: types.PUBLISH_MANUAL_VERSION_SIDEBAR,
    }),
  },
  setup() {
    return { toast: useToast(), v$: useVuelidate() }
  },
  validations() {
    return {
      version: { required },
      file: { required },
    }
  },
  methods: {
    ...mapMutations({
      mutatePublishManualVersionSidebar: types.MUTATE_PUBLISH_MANUAL_VERSION_SIDEBAR,
    }),
    ...mapActions({
      publishFranchiseManualVersion: types.PUBLISH_FRANCHISE_MANUAL_VERSION,
    }),
    async onSubmit() {
      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) return
      this.saving = true

      const content = {
        version: this.version,
        file: this.file,
        requires_new_acceptance: this.requiresNewAcceptance ? 1 : 0,
      }
      const request = new FormData()
      for (const [key, value] of Object.entries(content)) {
        if (value !== undefined && value !== null && value !== '') {
          request.append(key, value)
        }
      }

      this.publishFranchiseManualVersion({ id: this.publishManualVersionSidebar.id, request })
        .then(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Sucesso',
              text: 'Nova versão publicada com sucesso!',
              icon: 'CoffeeIcon',
              variant: 'success',
            },
          })
          this.publishManualVersionSidebar.saveAction()
          this.mutatePublishManualVersionSidebar({ visible: false })
        })
        .catch(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Oops!',
              text: 'Ocorreu um erro ao publicar a nova versão. Entre em contato com o setor de TI.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
        .finally(() => {
          this.saving = false
        })
    },
    clear() {
      this.version = undefined
      this.file = undefined
      this.requiresNewAcceptance = true
      this.saving = false
      this.v$.$reset()
      this.mutatePublishManualVersionSidebar({ id: undefined, manualName: undefined })
    },
  },
}
</script>
